import React from 'react';

type Props = {
  className?: string;
  size?: number;
};

const Icon: React.FC<Props> = ({
  className,
  size = 24,
}: Props) => (
<svg
  className={className}
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <mask id="mask0_4710_24547" style={{ maskType: 'alpha' as const }} maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
    <rect width="24.0012" height="24.0012" fill="#D9D9D9"/>
  </mask>
  <g mask="url(#mask0_4710_24547)">
    <path d="M4.0001 22.0011V11.0006H2V5.00027H7.20027C7.11693 4.85026 7.06276 4.69192 7.03776 4.52524C7.01276 4.35857 7.00026 4.18356 7.00026 4.00022C7.00026 3.16684 7.29194 2.45847 7.8753 1.87511C8.45867 1.29174 9.16704 1.00006 10.0004 1.00006C10.3838 1.00006 10.7421 1.0709 11.0755 1.21257C11.4088 1.35425 11.7172 1.55009 12.0005 1.8001C12.2839 1.53342 12.5922 1.33341 12.9256 1.20007C13.2589 1.06673 13.6173 1.00006 14.0006 1.00006C14.834 1.00006 15.5424 1.29174 16.1257 1.87511C16.7091 2.45847 17.0008 3.16684 17.0008 4.00022C17.0008 4.18356 16.9841 4.3544 16.9508 4.51274C16.9174 4.67108 16.8674 4.83359 16.8008 5.00027H22.001V11.0006H20.0009V22.0011H4.0001ZM13.2881 3.28768C13.0964 3.47936 13.0006 3.71687 13.0006 4.00022C13.0006 4.28356 13.0964 4.52108 13.2881 4.71275C13.4798 4.90443 13.7173 5.00027 14.0006 5.00027C14.284 5.00027 14.5215 4.90443 14.7132 4.71275C14.9048 4.52108 15.0007 4.28356 15.0007 4.00022C15.0007 3.71687 14.9048 3.47936 14.7132 3.28768C14.5215 3.096 14.284 3.00016 14.0006 3.00016C13.7173 3.00016 13.4798 3.096 13.2881 3.28768ZM9.00036 4.00022C9.00036 4.28356 9.0962 4.52108 9.28788 4.71275C9.47955 4.90443 9.71707 5.00027 10.0004 5.00027C10.2838 5.00027 10.5213 4.90443 10.713 4.71275C10.9046 4.52108 11.0005 4.28356 11.0005 4.00022C11.0005 3.71687 10.9046 3.47936 10.713 3.28768C10.5213 3.096 10.2838 3.00016 10.0004 3.00016C9.71707 3.00016 9.47955 3.096 9.28788 3.28768C9.0962 3.47936 9.00036 3.71687 9.00036 4.00022ZM4.0001 7.00037V9.00047H11.0005V7.00037H4.0001ZM11.0005 20.001V11.0006H6.00021V20.001H11.0005ZM13.0006 20.001H18.0008V11.0006H13.0006V20.001ZM20.0009 9.00047V7.00037H13.0006V9.00047H20.0009Z"
      fill="white"/>
  </g>
</svg>

);

export default Icon;
